import { useCallback } from 'react';

export const useSmoothScroll = () => {
  const scrollToSection = useCallback((targetId, offset = 100) => {
    const targetElement = document.getElementById(targetId);
    
    if (!targetElement) {
      console.warn(`Element with id "${targetId}" not found`);
      return;
    }

    // Get header height for offset
    const header = document.querySelector('header');
    const headerHeight = header ? header.offsetHeight : 80;
    
    // Calculate target position
    const targetPosition = targetElement.offsetTop - headerHeight - offset;
    
    // Use native smooth scrolling with fallback
    if ('scrollBehavior' in document.documentElement.style) {
      window.scrollTo({
        top: Math.max(0, targetPosition),
        behavior: 'smooth'
      });
    } else {
      // Fallback for older browsers
      const startPosition = window.pageYOffset;
      const distance = targetPosition - startPosition;
      const duration = 1000;
      let start = null;
      
      const animateScroll = (currentTime) => {
        if (start === null) start = currentTime;
        const timeElapsed = currentTime - start;
        const run = easeInOutCubic(timeElapsed, startPosition, distance, duration);
        window.scrollTo(0, run);
        if (timeElapsed < duration) requestAnimationFrame(animateScroll);
      };
      
      requestAnimationFrame(animateScroll);
    }
  }, []);

  // Easing function for fallback
  const easeInOutCubic = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t * t + b;
    t -= 2;
    return c / 2 * (t * t * t + 2) + b;
  };

  return { scrollToSection };
}; 